import { render, staticRenderFns } from "./Ecotableware.vue?vue&type=template&id=424152b6&scoped=true"
import script from "./Ecotableware.vue?vue&type=script&lang=js"
export * from "./Ecotableware.vue?vue&type=script&lang=js"
import style0 from "./Ecotableware.vue?vue&type=style&index=0&id=424152b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424152b6",
  null
  
)

export default component.exports